<template>
    <svg width="23" viewBox="0 0 23 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0517 7.373L14.1257 13.115L14.7182 13.815L23.0001 6.888L14.7182 0L14.1247 0.699997L21.0527 6.44301H0.916016V7.364H21.0517V7.373Z" fill="#0b3459"/>
    </svg>
</template>
<script>
    export default{

    }
</script>